module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "lg",
      "title": "Service Detail & Estimation",
      "hide-footer": ""
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.service) ? _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between mb-3 border-bottom pb-2"
  }, [_c('div', [_c('h5', {
    staticClass: "mb-0 text-primary"
  }, [_vm._v("Service: " + _vm._s(_vm.service.type))]), _vm._v(" "), _c('p', {
    staticClass: "small text-muted mb-0"
  }, [_vm._v("Ticket ID: #" + _vm._s(_vm.service.id) + " | Date: " + _vm._s(_vm.service.date))])]), _vm._v(" "), _c('b-badge', {
    staticClass: "p-2 h-50",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Estimated: ₹" + _vm._s(_vm.service.estimatedCost))])], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Complaint reported:")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.service.complaint))])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('strong', [_vm._v("Workshop location:")]), _vm._v(" "), _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("Pridel Maintenance Yard - Sector 5")])])], 1), _vm._v(" "), _c('h6', [_vm._v("Spare Parts & Labor Estimation")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-sm table-hover table-bordered"
  }, [_c('thead', {
    staticClass: "thead-light"
  }, [_c('tr', [_c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Price")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.spareParts), function(item, i) {
    return _c('tr', {
      key: i
    }, [_c('td', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.qty))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("₹" + _vm._s(item.price))])])
  }), _vm._v(" "), _c('tr', {
    staticClass: "bg-light font-weight-bold"
  }, [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total Estimation")]), _vm._v(" "), _c('td', {
    staticClass: "text-right"
  }, [_vm._v("₹" + _vm._s(_vm.service.estimatedCost))])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "mt-4 d-flex justify-content-between"
  }, [_c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('download-estimate', _vm.service)
      }
    }
  }, [_c('md-icon', {
    attrs: {
      "size": "18"
    }
  }, [_vm._v("download")]), _vm._v(" PDF Estimate\n          ")], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('go-to-maintenance', _vm.service)
      }
    }
  }, [_c('md-icon', {
    staticClass: "text-white",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("launch")]), _vm._v(" Open Native Record\n          ")], 1)], 1)], 1)], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66f0c23c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/ServiceEstimationModal.vue
// module id = 2697
// module chunks = 0